import { z } from "zod";

export const APPROVER_ROLES = ["owner", "manager", "cashier", "cook", "expo", "support"] as const;

export const createDiscountWorkflowId = (): string =>
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `tmp-${Math.random().toString(36).slice(2, 10)}`;

export type DiscountWorkflowFormValue = {
  id: string;
  name: string;
  thresholdCents: number;
  approverRoles: string[];
  escalationEmails: string[];
  requireReasonCode: boolean;
  createdAt: number;
  updatedAt: number;
};

export const discountWorkflowSchema = z.object({
  id: z.string().trim().min(4).max(64),
  name: z.string().trim().min(2).max(160),
  thresholdCents: z.number().int().min(0).max(1_000_000),
  approverRoles: z.array(z.enum(APPROVER_ROLES)).min(1),
  escalationEmails: z.array(z.string().trim().email()).max(10),
  requireReasonCode: z.boolean(),
  createdAt: z.number().int().min(0),
  updatedAt: z.number().int().min(0),
});

export const discountWorkflowsSchema = z.array(discountWorkflowSchema).max(20);
